import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e009019&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2e009019&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e009019",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/about/concat-us/index.vue
// module id = null
// module chunks = 